<template>
<div class="modal" tabindex="-1" role="dialog">
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <div class="modal-header p-3">
          <h6 class="modal-title">{{headerName?headerName:$t('Add User')}}</h6>
          <button type="button" class="close text-white" data-dismiss="modal" aria-label="Close" @click="close">
            <span aria-hidden="true"><close-icon class="close-icon" style="height: 30px !important;
    width: 30px !important;
    color: #fff;"></close-icon></span>
          </button>
        </div>
        <div class="modal-body">
          <Multiselect
            v-model="selectedUsers" 
            :options="allUsersList"
            track-by="_id"
            label="username"
            :close-on-select="true"
            deselectLabel =""
            selectLabel=""
            selectedLabel=""
            ref="messageUsers"
            :placeholder="$t('Select user')" 
            :hideSelected="false"
            @select="selectedUserOptions($event)"
            :searchable="true"
            :class="!this.selectedStage && !this.selectedButton?'':'add-search-filter-stages'"
            @search-change="handleSearchChange"
            >
            <div style="display:flex;max-height:12px;align-items:center;" class="checkbox-label" slot="option" slot-scope="scope">
              <div :title="scope.option.username" v-if="Object.keys(scope.option).includes('profile_image') && !['undefined',null].includes(scope.option.profile_image) && scope.option.profile_image" class='user-name-or-image-in-selected-option'>
                <img :src="getProxyConvertedImage(scope.option.profile_image)" @error="replaceWithUserIcon($event)" style="width:100%;height:100%;border-radius:6px;margin-bottom: 5px;">
              </div>
              <div v-else class="user-name-or-image-in-selected-option" :style="style(scope.option.username)">{{ scope.option.username.split("")[0] }}</div>
                <span style="margin-inline-start:12px;">{{ scope.option.username }}</span>
              </div>
              <span slot="noResult">No results</span>
              <span slot="noOptions" style="display:none"></span>
          </Multiselect>
            </div>
        <div class="modal-footer p-0 primary-btn-style">
          <button class="btn btn-outline-secondary mr-3" data-dismiss="modal" @click="close">{{$t('Cancel')}}</button>
          <button class="btn btn-outline-primary mr-3" @click.prevent="updateUserGroup()">{{$t('Add')}}</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {mapActions} from "vuex";
import closeIcon from "../core/InlineCancelField.vue";
import Utils from "../../components.utils.js";
import Multiselect from 'vue-multiselect';

export default {
  props:["headerName","selectedStage","selectedButton","isEditGroup","selectedUsersList","enableCustomisedActionsForReview","privilegeCheck"],
  data: () => ({
    dialog: true,
    userTypes: [],
    userTypesOptions: [],
    selectedUserIdNameMap:{},
    selectedUserIds:[],
    postData: {},
    addedUser:null,
    show:false,
    selectedUsers: [],
    allUsersList:[],
  }),
  components:{
    "Multiselect":Multiselect,
    "close-icon":closeIcon,
  },
  methods:{
    getProxyConvertedImage(image_url){
       return Utils.convertToLoginIPDomainName(image_url);
    },
    handleSearchChange(option) {
      if (!this.selectedStage && !this.selectedButton) {
        this.getusersOnKeyup(option);
      }
    },
    close(){
        this.$emit('close',null),
        this.$emit('closeUserAddition')
    },
    style(name){
        let style = {
        'color':Utils.textColor(Utils.intToRGB(Utils.hashCode(name))),
        'background-color':'#'+Utils.intToRGB(Utils.hashCode(name))
        }
        return style
    },
    getusersOnKeyup(option){
      let payload = {}
      if(typeof(option) != "undefined" && option.trim().length > 0){
        payload.params = {username:option}
        this.getUsersAutoComplitionFromServer(payload).then((data) => {
          this.allUsersList = data["users"];
        });
      }else{
        if(this.selectedStage && this.selectedButton){
          payload = {'_id':this.selectedStage._id,'button_id':this.selectedButton.button_id}
          this.getStageUsersFromServer(payload).then((data) => {
            this.allUsersList = data.users;
          })
        }else{
          this.getAllUsersFromServer().then((data) => {
            this.allUsersList = data.users;
          })
        }
      }
    },
    replaceWithUserIcon(e){
      e.target.onerror = null
      e.target.src = Utils.getNoThumbnailImg();
    },
    selectedUserOptions(option){
      this.userTypes = option;
    },
    updateUserGroup(){
      this.$emit('close',this.selectedUsers)
      this.$emit('closeUserAddition',this.selectedUsers)
    },
    ...mapActions("mediaPipeline", ["getAllAssetsFromServer","getStageUsersFromServer"]),
    ...mapActions("users", ["getUsersAutoComplitionFromServer","getAllUsersFromServer"]),
    ...mapActions("userGroups", ["updateExistingUserGroup"]),
  },
  created(){
    let payload = {};
    if(this.selectedStage && this.selectedButton){
      payload = {'_id':this.selectedStage._id,'button_id':this.selectedButton.button_id}
      this.getStageUsersFromServer(payload).then((data) => {
        this.allUsersList = data.users;
      })
    }else{
      this.getAllUsersFromServer().then((data) => {
        this.allUsersList = data.users;
      })
    }
  },
  mounted(){
    setTimeout(() => {
      this.show = true;
    }, 200)
  },
}
</script>

<style lang="scss" scoped>
  $table-row-border: none;
$active-blue: #007bff;
$danger-color: #dc3545;
$none-text-color:#4f4f4f;
$add-button-text-color:#0b7099;
$add-button-text-color-hover:#0193cc;
$add-button-border-color:#b7b228;
$add-button-border-on-hover:#dcd426;
$add-button-backgroud:#1e1e1e;
$active-green-color:#28a745;
$primary-background: #1a1e21;
$border-color: 1px solid #4a4a4a;
$primary-background: #1a1e21;
$secondary-background-color:#15181B;
$bg-color-on-hover: #22272b;
$text-color: #eee;
$dull-text-color: #757575;
$secondary-text-color: #9c9c9c;
$active-blue : #007bff;
$input-field-and-label-font-size:14px;
$input-field-height:38px;
$highlight-font-color:#ff9800;
$scrollbar-thumb-background:#333;
$scrollbar-track-background:#1a1e21;
$scrollbar-thumb-on-hover-background:#555; 
$input-field-padding:.375rem 10px;
$filter-border-color: #5a5a5a;
$filter-bg-color: #2a2a2a;
$learn-about-text-color-hover:#b7b327;
$learn-about-text-color:#9a9620;
$tags-background-color:#282d31;
$svg-color:#666;
$tags-border-color:#363636;
$secondary-border-color: 1px solid #2b2b2b;
$icon-hover:#2c3339;

.modal-dialog {
    max-width: 600px;
    width: 600px;
    margin: 0;
    padding: 0;
  }

  .modal{
    transition: opacity .3s ease;
  }

  
  .modal-content {
    height: auto;
    min-height: 100%;
    border: 0 none;
    border-radius: 0;
    box-shadow: none;
    background: $primary-background !important;
    border: $secondary-border-color;
    .modal-body{
      background: $primary-background;
      padding: 2rem;
    }
  }

.modal {
    text-align: center;
    padding: 0 !important;
    display: block;
    position: fixed;
    inset-inline-start: 0px;
    top: 20% !important;
}
.modal-header .close {
    // margin: -1rem -13px -1rem auto !important;
     margin:0px !important;
    padding: 0px !important;
}
.modal:before {
  content: '';
    display: inline-block;
    height: 100vh;
    vertical-align: middle;
    margin-inline-end: -4px;
    position: fixed;
    width: 100vw;
    inset-inline-start: 0;
    top: 0;
    background: #00000094;
}
.modal-dialog {
  display: inline-block;
  text-align: start;
  vertical-align: middle;
}

.btn{
    font-size:$input-field-and-label-font-size !important;
    height:100%;
}

.border{
    border: $border-color !important;
}

.modal-header,.modal-footer{
    border-top: $secondary-border-color !important;
    border-bottom: $secondary-border-color !important;
    background: $secondary-background-color;
    height: 58px;
    .modal-title{
      color:$text-color;
    }
}

.primary-btn-style{
    button{
        height: 35px;
        width: 70px;
        font-size:$input-field-and-label-font-size;
    }
}

.secondary-btn-style{
  color:$text-color;
}

.key-style {
  color: $dull-text-color;
  width: 30%;
  text-align: start;
  font-size: $input-field-and-label-font-size;
  padding-inline-start: 5px;
  padding-inline-end: 5px;
  margin-top: 3px;
}

.close-icon:hover{
  background: $icon-hover;
  border-radius: 20px;
}

.bigger-checkboxes {
    height: 30px;
    width: 20px;
    position:relative;
}
input[type="checkbox"]:after {
    line-height: 1.5em;
    content: "";
    display: inline-block !important;
    width: 22px !important;
    height: 21px !important;
    margin-top: 5px !important;
    margin-inline-start: -1px !important;
    border: $border-color !important;
    border-radius: 0.25em !important;
    background: $primary-background !important;
}
input[type="checkbox"]:checked:after {
    content: "✔";
    color: $active-blue !important;
    position: absolute !important;
    font-size: 16px !important;
    line-height: 1 !important;
    transition: all 0.2s !important;
    font-family: Helvetica, Arial, sans-serif;
    padding-inline-start: 4px !important;
    padding-top: 2px !important;
}

.user-name-or-image{
    height: 30px;
    width: 30px;
    border: $border-color;
    border-radius: 10px;
    text-align: center;
    line-height: 28px;
    text-transform: uppercase;
    margin-top: 3px;
}

.tags-style{
    display: flex;
    height: fit-content;
    padding: 5px;
    width: auto;
    border-radius: 11px;
    margin-inline-end:0px 5px;
    .user-name-display{
        line-height: 33px;
        padding-inline-start: 5px;
    }
    .remove-tag{
        line-height: 32px;
        position: relative;
        inset-inline-start: 5px;
        svg{
            height:30px !important;
        }
    }
}

   ::v-deep{
    .add-search-filter{
        display: inline-flex;
        border: 1px solid #0779fb !important;
        color: #0779fb !important;
        .add-fileds-icon{
            position: absolute;
            inset-inline-start: 10px;
            z-index: 99;
            top: 13px;
        }
        .multiselect{
            min-width:15%;
            margin: -2px 0px;
            .multiselect__tag{
                display:none;
            }
            .multiselect__select{
                display:none;
            }
        }
    }
    .multiselect{
            width:100%;
            margin: 3px 0px;
    }
    .multiselect__content-wrapper{
        display:none;
    }
    .multiselect__tag, .tags-style {
        background-color: $primary-background !important;
        border: $border-color;
        border-radius: 5px;
        margin-bottom:0px;
    }
    .multiselect__tags, .tags-style {
        background: $primary-background !important;
        border: $border-color !important;
    }
        .multiselect__option--highlight {
            background: $bg-color-on-hover !important;
        }
        .multiselect__content {
            background: $secondary-background-color !important;
        }
        .multiselect__input, .multiselect__single {
            background: transparent !important;
            color:$text-color;
        }
        .multiselect__input:focus{
            outline:none;
            box-shadow: none;
        }
        .multiselect__tag-icon{
        color:$text-color;
        }
        .multiselect__tag-icon:focus, .multiselect__tag-icon:hover {
            background: $bg-color-on-hover !important;
            color: $text-color !important;
        }
        .multiselect__tag-icon:after{
        color:$secondary-text-color !important;
        font-size: 20px;
        }
        .multiselect *{
            font-size: $input-field-and-label-font-size;
            font-family: "Roboto", Arial, sans-serif !important;
        }
        .multiselect__tags{
            display: block;
            align-items: center;
        }
        .multiselect__placeholder {
            margin-bottom:0px;
            color:#5d5d5d !important;
        }
        .multiselect{
            color:$text-color !important;
            font-size: $input-field-and-label-font-size !important;
            min-height: 38px;
        }
        .multiselect__single{
            padding-top:0px !important;
        }
        .multiselect__option--selected{
            background: $bg-color-on-hover !important;
            color: $text-color;
        }
        .multiselect__content-wrapper{
            border: 1px solid $bg-color-on-hover !important;
            position: absolute !important;
            display: block;
            background: $text-color;
            width: 100% !important;
            max-height: 150px;
            overflow: auto;
            border: 1px solid $text-color;
            border-top: none;
            border-bottom-left-radius: 5px;
            border-bottom-right-radius: 5px;
            z-index: 50;
            -webkit-overflow-scrolling: touch;
        }
        .multiselect__select,.multiselect__current,.multiselect__option{
            line-height: 24px !important;
        }
        .multiselect--above .multiselect__content-wrapper{
        background: $secondary-background-color !important;
        }
        .multiselect__tags {
            background: $primary-background!important;
            height: 40px !important;
        }
        .filter-wrapper{
            display:inline-flex;
            align-items: center;
            border: $border-color;
            border-radius: 5px;
            background: $primary-background;
            color:$dull-text-color;
            .filter-label{
                margin:0px 4px;
                width: auto;
                white-space: nowrap;
            }
            .comm-input-field-style,.multiselect__tags{
                border: none !important;
                border-radius: none !important;
            }
            .mx-input{
                height:38px;
            }
            .multiselect{
                margin:0px !important;
            }
        }
        .add-search-filter-stages{
          .multiselect__placeholder{
            padding-top:7px !important;
          }
        }
    }

    .user-name-or-image{
      height: 60px;
      width: 60px;
      border: $border-color;
      border-radius: 10px;
      text-align: center;
      line-height: 56px;
      text-transform: uppercase;
      margin: 0 auto;
      font-size: 30px;
  }

    .user-name-or-image-in-selected-option{
      border: 1px solid #3a3a3a;
      height: 27px;
      width: 27px;
      border-radius: 5px;
      text-align: center;
      line-height: 26px;
      text-transform: uppercase;
      margin-top: -1px;
      margin-inline-start: -1px;
      }


</style>